import React from 'react'

export const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <ul id="subFooterLinks">
                            <li><a href="https://odidor.co/" target='_blank' >Powered  <i className="fa fa-heart pulse"></i> by Odidor</a></li>
                        </ul>
                    </div>
                    <div className="col-md-4">

                        <div id="copy">
                            <a href="https://odidor.co/" target='_blank'>© Odidor
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </footer>

    )
}
